import AddWork from '@/apps/AddWork'
import Layout from '@/apps/layout/components'
import React from 'react'

const AddWorkPage = (): React.ReactElement => {
  return (
    <Layout>
      <AddWork />
    </Layout>
  )
}

export default AddWorkPage
